import React from "react";
import * as R from "ramda";
import { Progress } from "antd";
import { useTranslation } from "react-i18next";

import styled from "styled-components/macro";

const Percentage = styled.div`
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const HumanTestWrapper = styled.div`
  p.khorInt_Titulo1 {
    font-weight: bold;
    border-bottom: 1px solid #00000024;
    padding-bottom: 0.5em;
    margin-bottom: 0.5em;
  }
`;

export default function HumanTest({
  serviceCallRequest,
  resultsRange = 100,
  showOriginalNumber = false
}) {
  const { t } = useTranslation(["opportunity"]);

  try {
    // Human Group sometimes sends the object stringified...
    const result =
      typeof serviceCallRequest === "object"
        ? serviceCallRequest
        : typeof serviceCallRequest === "string"
        ? JSON.parse(serviceCallRequest)
        : null;

    const interpretation = R.either(
      R.path(["interpretacion", "texto"]),
      R.path(["resultados", "interpretacion", "texto"])
    )(result);

    const results = R.either(
      R.path(["resultados", "factores"]),
      R.path(["resultados"])
    )(result);

    const resultsMultiplier = 100 / resultsRange;

    return (
      <HumanTestWrapper>
        {interpretation && (
          <div dangerouslySetInnerHTML={{ __html: interpretation }} />
        )}
        {Array.isArray(results) ? (
          results.map(({ factor, nombrefactor, resultado }) => {
            const percentage = resultado * resultsMultiplier;
            const number = showOriginalNumber ? resultado : percentage;
            return (
              <Percentage key={factor}>
                <span data-test={`english-test-${factor}`}>
                  {`${nombrefactor || factor}${
                    resultsRange === 100 ? ` (${number}%)` : `: ${number}`
                  }`}
                </span>
                <Progress
                  percent={percentage > 1 ? percentage : 1}
                  showInfo={false}
                  strokeColor={R.cond([
                    [R.gte(40), R.always("#F5242E")],
                    [R.gte(60), R.always("#e0b500")],
                    [R.gte(100), R.always("#53C819")]
                  ])(percentage)}
                />
              </Percentage>
            );
          })
        ) : (
          <Percentage>
            <Progress
              percent={results.resultado * resultsMultiplier}
              showInfo={false}
              strokeColor={R.cond([
                [R.gte(40), R.always("#F5242E")],
                [R.gte(60), R.always("#e0b500")],
                [R.gte(100), R.always("#53C819")]
              ])(results.resultado * resultsMultiplier)}
            />
          </Percentage>
        )}
      </HumanTestWrapper>
    );
  } catch (e) {
    console.error(e);
    return (
      <HumanTestWrapper>
        <p>{t("opportunity:process.candidateDetails.testVisualizeError")}</p>
      </HumanTestWrapper>
    );
  }
}
